export function normalizujCislo(hodnota) {
  if (hodnota == null) return NaN;

  if (typeof hodnota === 'number') {
    return Number.isFinite(hodnota) ? hodnota : NaN;
  }

  if (typeof hodnota === 'string') {
    const ciste = hodnota
      .replace('%', '')
      .replace('€', '')
      .replace(/\s/g, '')
      .replace(',', '.');

    const n = Number(ciste);
    return Number.isFinite(n) ? n : NaN;
  }

  return NaN;
}

// zachované správanie ako v BE (vracia + pri kladných číslach)
export function formatujPercentoText(hodnota) {
  const cislo = normalizujCislo(hodnota);
  if (!Number.isFinite(cislo) || cislo === 0) return '0,00 %';

  const znamienko = cislo > 0 ? '+' : '';
  const s = cislo.toFixed(2).replace('.', ',');
  return `${znamienko}${s} %`;
}

// FE varianta bez znamienka (potrebná pre Úrokovú sadzbu)
export function formatujPercentoBezZnamienkaText(hodnota) {
  const cislo = normalizujCislo(hodnota);
  if (!Number.isFinite(cislo)) return '0,00 %';

  const s = cislo.toFixed(2).replace('.', ',');
  return `${s} %`;
}

export function eur(x) {
  const v = Number(x ?? 0);
  const safe = Math.abs(v) < 0.5 ? 0 : v;
  return safe.toLocaleString('sk-SK');
}